// Links das lojas e redes do FitClutch (um lugar só). Quando o app entrar na
// App Store, é só preencher APPSTORE_URL aqui (e a env APPSTORE_URL na Netlify,
// usada no e-mail de boas-vindas) — o botão da Apple passa a funcionar sozinho.
export const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.fitclutch.app';
export const APPSTORE_URL = 'https://apps.apple.com/app/fitclutch/id6806713666';

export const SITE_URL = 'https://appfitclutch.com';
export const PRIVACY_URL = `${SITE_URL}/privacy.html`;
export const TERMS_URL = `${SITE_URL}/terms.html`;
export const CONTACT_EMAIL = 'contact@appfitclutch.com';
export const INSTAGRAM_URL = 'https://www.instagram.com/fitclutch.en';
export const TIKTOK_URL = 'https://www.tiktok.com/@fitclutch.app';
